module.exports = __webpack_public_path__ + "img/calendar-heart-01.1b9f766b.svg";